// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Download } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconDownload(props: any) {
    return <IconBase icon={Download} {...props} />
  }

  export default IconDownload
  